import React from 'react';
import EyeIcon from 'src/common/utils/TableColumnIcons/EyeIcon';
import TrashIcon from 'src/common/utils/TableColumnIcons/TrashIcon';
import RepeatIcon from 'src/common/utils/TableColumnIcons/RepeatIcon';

export const ActionColumnFormat = (
	value,
	row,
	rowIndex,
	{ onRepeat, onEye, onDelete, disableBoton }
) => {
	return (
		<>
			<EyeIcon onClick={() => onEye(value)} color="primary" />
			<TrashIcon
				onClick={() => onDelete(value)}
				className={disableBoton === true ? 'd-none' : 'ml-2'}
			/>
			<RepeatIcon
				onClick={() => onRepeat(row)}
				className={disableBoton === true ? 'd-none' : 'ml-2'}
				tooltip="Cambiar estatus"
			/>
		</>
	);
};
